module.exports = __webpack_public_path__ + "static/home-train-station-126beded7250a77b165c9f9d79adba96.jpg";